<div class="d-flex flex-column w-100">
	<div class="card">
		<div class="display-14">
			{{ activeUserMessage }}
		</div>
		<div class="display-14 text-danger">{{ errorMessage }}</div>
	</div>
	<div class="mx-auto" *ngIf="displayRetry">
		<p-button pRipple styleClass="p-button-raised p-button-warning m-2" [disabled]="!displayRetry" (click)="retry()">
			<ng-template pTemplate="content">
				<div class="flex justify-content-center">Try again</div>
			</ng-template>
		</p-button>
	</div>
	<mat-progress-bar *ngIf="!displayRetry" mode="indeterminate"></mat-progress-bar>
</div>
